module.exports = __webpack_public_path__ + "static/media/border.8c1532df.png";